module.exports = __webpack_public_path__ + "static/kuruyemisborsasi-web-bae689c70ce3a59237af19e3a70abcf2.jpg";